import { LightningElement, track, api } from 'lwc';

/*
    Example setup:
        
        Initialize the modal (JS):
            this.querySelector('x-slds-modal').showMe()

        Add the component to the markup (HTML):
            <x-slds-modal
                modal-message="My modal message."
                cancel-button-label="Cancel"
                okay-button-label="Okay"
                onmodalclick={handleModalClick}
            ></x-slds-modal>

        Handle the modal message (JS):
            handleModalClick(message) {
                const detail = message.detail; 
                if (detail === 'cancel') { // do something }
                if (detail === 'okay') { // do something else }
            }
*/

export default class sldsModal extends LightningElement {
    static renderMode = 'light';

    @api childComponent;
    @track displayModal = false;

    @api 
    set modalMessage(value) {
        this._modalMessage = value;
    }
    get modalMessage() {
        return this._modalMessage;
    }

    @api 
    set cancelButtonLabel(value) {
        this._cancelButtonLabel = value;
    }
    get cancelButtonLabel() {
        return this._cancelButtonLabel;
    }
    
    @api 
    set okayButtonLabel(value) {
        this._okayButtonLabel = value;
    }
    get okayButtonLabel() {
        return this._okayButtonLabel;
    }


    @api showMe() {
        this.displayModal = true;
    }
    @api hideMe() {
        this.displayModal = false;
    }

    handleCancel() {
        this.displayModal =  false;
        this.dispatchEvent(new CustomEvent('modalclick', {
            detail: 'cancel',
            bubbles: false,    
            composed: true     
        }));
    }

    handleOkay() {
        this.displayModal = false;
        this.dispatchEvent(new CustomEvent('modalclick', {
            detail: 'okay',
            bubbles: false,    
            composed: true     
        }));
    }
    
}